module.exports = __webpack_public_path__ + "static/media/pla_con_ski.45fb3230.png";